// src/app/App.jsx
import React, { useEffect } from "react";
import TenantBrandingProvider from "../shared/branding/TenantBrandingProvider";
import AppRouter from "./router";
import "../styles/global.css";
import "../i18n";
import SessionTimeoutProvider from "../shared/session/SessionTimeoutProvider";
import { attachAuthGuards } from "../utils/attachAuthGuards";

export default function App() {
  useEffect(() => {
    attachAuthGuards();
  }, []);

  return (
    <SessionTimeoutProvider>
      <TenantBrandingProvider>
        <AppRouter />
      </TenantBrandingProvider>
    </SessionTimeoutProvider>
  );
}
